<style lang="scss">
  .video-modal-wrapper {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 10000;
    opacity: 0;
    transition: opacity 0.2s, visibility 0s 0.2s;
    visibility: hidden;

    &.visible {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.2s;
    }

    .background {
      position: absolute;
      width: 100vw;
      height: 100vh;
      background-color: rgba(255, 255, 255, 0.9);
      left: 0;
      top: 0;
      cursor: pointer;
    }

    iframe {
      aspect-ratio: 16/9;
      width: 100%;
      height: auto;
    }
  }

  .video-modal {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.16);
    border-radius: 4px;
    background-color: #ffffff;
    width: calc(100% - 32px);

    @media screen and (min-width: 768px) {
      width: 712px;
    }

    @media screen and (min-width: 1440px) {
      width: 1024px;
    }

    @media screen and (min-width: 1680px) {
      width: 1280px;
    }
  }
</style>

<template>
  <div class="video-modal-wrapper px-16" :class="{ visible: isVisible }">
    <div class="background" @click="close()"></div>
    <div class="video-modal">
      <div class="modal-inner">
        <div class="video-wrapper">
          <video ref="player" v-if="videoId.includes('.mp4')" autoplay controls>
            <source :src="videoId" type="video/mp4" />
          </video>
          <iframe
            v-else-if="isVisible"
            :src="`https://player.vimeo.com/video/${videoId}?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media`"
            allowfullscreen
            allowtransparency
            allow="autoplay"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      videoId: {
        type: String,
        required: true,
      },
      open: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        player: null,
      };
    },

    mounted() {
      var self = this;
      document.onkeydown = function(evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
          isEscape = evt.key === "Escape" || evt.key === "Esc";
        } else {
          isEscape = evt.keyCode === 27;
        }
        if (isEscape) {
          self.close();
        }
      };
    },

    methods: {
      close() {
        this.$emit("close");
      },
    },

    computed: {
      isVisible() {
        return this.open;
      },
    },

    watch: {
      open: function(newVal, oldval) {
        if (newVal) {
          document.getElementsByTagName("body")[0].classList.add("video-modal-active");
          document.getElementsByTagName("header")[0].style.zIndex = "1";
        } else {
          document.getElementsByTagName("body")[0].classList.remove("video-modal-active");
          document.getElementsByTagName("header")[0].style.zIndex = "5";
        }
      },
      isVisible: function(newVal, oldval) {
        this.$nextTick(() => {
          if (newVal) {
            if (this.videoId.includes(".mp4")) {
              this.$refs.player.play();
            }
          } else {
            if (this.videoId.includes(".mp4")) {
              this.$refs.player.pause();
            }
          }
        });
      },
    },
  };
</script>
